import React, { useState } from 'react';
import axios from 'axios';
import { UserCheck, RefreshCw, ChevronDown, ChevronUp } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const Lista = ({ titulo, filas, color, testid, conMotivo }) => (
  <div data-testid={testid}>
    <p className={`font-medium ${color}`}>{titulo} ({filas.length})</p>
    {filas.length === 0 ? <p className="text-gray-400 pl-2">Nadie</p> : (
      <ul className="pl-2 divide-y divide-gray-100">
        {filas.map((f, i) => (
          <li key={i} className="flex items-baseline justify-between gap-3 py-0.5" data-testid={`${testid}-fila-${i}`}>
            <span className="text-gray-700 break-words min-w-0">
              {f.nombre}
              {f.nombre_meet && <span className="text-gray-400"> · en Meet: {f.nombre_meet}</span>}
              {conMotivo && f.motivo && <span className="text-gray-400"> · {f.motivo}</span>}
            </span>
            <span className="text-gray-500 tabular-nums flex-shrink-0">{f.minutos} min</span>
          </li>
        ))}
      </ul>
    )}
  </div>
);

const Detalle = ({ a, id }) => {
  if (!a.presentes_detalle) {
    return (
      <div className="text-gray-600 space-y-0.5">
        {a.presentes_nombres?.length > 0 && <p>Presentes: {a.presentes_nombres.join(', ')}</p>}
        {a.tiempo_insuficiente?.length > 0 && <p>Menos del 50% del tiempo: {a.tiempo_insuficiente.join(', ')}</p>}
        <p className="text-gray-400">Tocá "Volver a traer" para ver los minutos de cada participante.</p>
      </div>
    );
  }
  return (
    <div className="space-y-2 pt-1" data-testid={`asistencia-detalle-${id}`}>
      <Lista titulo="Presentes" filas={a.presentes_detalle} color="text-green-700" testid={`asistencia-presentes-${id}`} />
      <Lista titulo={`Menos del 50% del tiempo (mínimo ${a.minimo_minutos} de ${a.duracion_programada} min)`}
        filas={a.insuficientes_detalle || []} color="text-amber-700" testid={`asistencia-insuficientes-${id}`} />
      {a.no_identificados?.length > 0 && (
        <Lista titulo="Sin identificar (marcar a mano si corresponde)" filas={a.no_identificados} color="text-gray-600"
          testid={`asistencia-no-identificados-${id}`} conMotivo />
      )}
    </div>
  );
};

export const AsistenciaZoomPanel = ({ reunion: r, spaceId, headers, onDone }) => {
  const [cargando, setCargando] = useState(false);
  const [jornada, setJornada] = useState('');
  const [abierto, setAbierto] = useState(true);
  const a = r.asistencia_zoom;
  const fuente = r.plataforma === 'meet' ? 'Google Meet' : 'Zoom';

  const traer = async () => {
    setCargando(true);
    try {
      await axios.post(`${API_URL}/campus/espacios/${spaceId}/reuniones/${r.id}/asistencia-zoom`,
        { jornada_id: jornada || null }, { headers });
      onDone();
    } catch (err) {
      alert(err.response?.data?.detail || 'No se pudo traer la asistencia');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="mt-3 p-2.5 rounded-md bg-gray-50 border text-xs space-y-1.5" data-testid={`asistencia-zoom-${r.id}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <UserCheck className="w-3.5 h-3.5 text-violet-600" />
        <span className="font-medium text-gray-700">Asistencia desde {fuente}</span>
        {!a && <span className="text-gray-500">se carga sola unos 30 min después de terminar</span>}
        {a?.estado === 'ok' && (
          <button type="button" onClick={() => setAbierto(!abierto)} className="inline-flex items-center gap-1 text-green-700"
            data-testid={`asistencia-zoom-ok-${r.id}`}>
            {a.presentes} presente{a.presentes === 1 ? '' : 's'} en {a.jornada_etiqueta}
            {abierto ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
          </button>
        )}
        {a && a.estado !== 'ok' && <span className="text-amber-700" data-testid={`asistencia-zoom-error-${r.id}`}>{a.error}</span>}
        <button type="button" onClick={traer} disabled={cargando} data-testid={`traer-asistencia-${r.id}`}
          className="ml-auto inline-flex items-center gap-1 px-2 py-1 rounded bg-white border hover:bg-violet-50 text-violet-700 disabled:opacity-60">
          <RefreshCw className={`w-3 h-3 ${cargando ? 'animate-spin' : ''}`} /> {a ? 'Volver a traer' : 'Traer ahora'}
        </button>
      </div>
      {a?.estado === 'sin_clase' && (
        <select className="border rounded px-1.5 py-1 bg-white" value={jornada} onChange={e => setJornada(e.target.value)}
          data-testid={`asistencia-jornada-${r.id}`}>
          <option value="">Elegí la clase…</option>
          {(a.jornadas || []).map(j => <option key={j.id} value={j.id}>{j.etiqueta} · {j.fecha}</option>)}
        </select>
      )}
      {a?.estado === 'ok' && abierto && <Detalle a={a} id={r.id} />}
    </div>
  );
};
